import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64468884"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { id: "head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, " 吾爱吾庐-简迹 ", -1))
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "top-button",
  onclick: "goAnchor('head')"
}, [
  /*#__PURE__*/_createTextVNode("回到"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("顶部")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  id: "foot",
  style: {"z-index":"100"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "浙ICP备17027825号-1", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: " blank ",
    href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33078302100258",
    style: {"display":"inline-block","text-decoration":"none","height":"20px","line-height":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/beianlogo.d0289dc.png",
      alt: "beian",
      style: {"float":"left"}
    }),
    /*#__PURE__*/_createTextVNode("浙公网安备 33078302100258号 ")
  ]),
  /*#__PURE__*/_createTextVNode(" ")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"height":"30px"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: " blank ",
    href: "http://creativecommons.org/licenses/by-nc-nd/4.0/",
    rel: "license"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "知识共享协议",
      i: "",
      src: "/ccbyncnd.png",
      style: {"border-width":"0px","height":"30px","width":"auto"}
    })
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Copyleft", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block","transform":"rotate(180deg)"} }, " © ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://jett.ink" }, "jett zhu", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "townsquare-root",
  style: {"margin-top":"80px","height":"180px"}
}, null, -1))

import { ref, onMounted } from 'vue';
import { useRoute, onBeforeRouteUpdate } from 'vue-router';
import axios from 'axios';
import TyporaParser from 'typora-parser';
import HighlightJsRenderer from 'typora-parser/build/src/plugins/HighlightJsRenderer';
// import StubCodeRenderer from 'typora-parser/build/src/plugins/StubCodeRenderer';
import MathJaxRenderer from 'typora-parser/build/src/plugins/MathJaxRenderer';
// import StubLatexRenderer from 'typora-parser/build/src/plugins/StubLatexRenderer';
// import SimpleUrlResolver from 'typora-parser/build/src/plugins/SimpleUrlResolver';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const goAnchor = (id: string) => {
  // console.log(id);
  let anchor = document.getElementById(id);
  if (!anchor) {
    // anchor = document.getElementsByName(id)[0];
    [anchor] = document.getElementsByName(id);
  }
  try {
    if (!anchor) return;
    document.body.scrollTop = anchor.offsetTop;
    document.documentElement.scrollTop = anchor.offsetTop;
    window.scrollY = anchor.offsetTop;
  } finally {
    // do nothing
  }
};
// document.goAnchor = goAnchor;

const { params } = useRoute();
const content = ref('');
const timestr = ref('2023年');

const replaceHrefInHtml = (htmlStr: string) => {
  // 创建一个虚拟的 DOM 元素，用于解析 HTML 字符串
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlStr, 'text/html');

  // 获取所有以 '#' 开头的 <a> 标签
  const anchorTags = doc.querySelectorAll('a[href^="#"]');

  // 遍历每个匹配的 <a> 标签
  anchorTags.forEach((anchorTag) => {
    // 获取当前 href 属性的值
    const currentHref = anchorTag.getAttribute('href');
    if (!currentHref) return;
    // 删除 开头的 # 字符
    const newHref = currentHref.slice(1);
    // 添加 onclick 属性，调用 goAnchor 函数，参数为当前 href 的值
    anchorTag.setAttribute('onclick', `goAnchor('${newHref}')`);
    // 替换 href 属性为 javascript:void(0)
    // anchorTag.setAttribute('href', 'javascript:void(0)');
    anchorTag.removeAttribute('href');
  });

  // 将修改后的 DOM 转换回字符串
  const modifiedHtmlStr = new XMLSerializer().serializeToString(doc);

  return modifiedHtmlStr;
};

// 将 `[[LINK|LABEL]]` 替换为 `[LABEL](LINK.md)`
// 将 `![[LINK|LABEL]]` 替换为 `![LABEL](LINK)`
const replaceLink = (mdInput: string): string => mdInput.replace(
  /(!?)\[\[([^\]|]+)(?:\|([^\]]+))?\]\]/g,
  (_match, prefix, link, label) => (prefix === '!'
    ? `![${label || link}](${link})`
    : `[${label || link}](/#/${link}.md)`),
);

const getHtmlFromMd = (mdInput: string) => {
  const replaced = replaceLink(mdInput);
  const parseResult = TyporaParser.parse(replaced);
  const html = parseResult.renderHTML({
    codeRenderer: new HighlightJsRenderer({
      displayLineNumbers: true,
    }),
    latexRenderer: new MathJaxRenderer(),
  });
  return replaceHrefInHtml(html);
};

onMounted(() => {
  // console.log('mounted');
  // console.log(params.path);
  setInterval(() => {
    // 更新时间到 timestr 年 月 日 时 分，月日时分均两位数
    const date = new Date();
    const year = date.getFullYear();
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    const hour = `0${date.getHours()}`.slice(-2);
    const minute = `0${date.getMinutes()}`.slice(-2);
    timestr.value = `${year}年${month}月${day}日 ${hour}:${minute}`;
  }, 1000);
  let path = '';
  if (params.path) {
    path = params.path as string;
  } else if (params.path === '/') {
    path = '/blog/Home.md';
  } else if (params.path === '/Home.md') {
    path = '/blog/Home.md';
  } else if (params.path === 'Home.md') {
    path = '/blog/Home.md';
  } else {
    path = '/blog/Home.md';
  }
  axios.get(`${path}`).then((res) => {
    // console.log(res.status);
    // console.log(res.data);
    try {
      content.value = getHtmlFromMd(res.data);
    } catch (e) {
      // console.error(e);
      axios.get('/blog/404.md').then((res2) => {
        content.value = getHtmlFromMd(res2.data);
      });
    }
  }).catch((err) => {
    axios.get('/blog/404.md').then((res2) => {
      try {
        content.value = getHtmlFromMd(res2.data);
      } catch (e) {
        console.log(e);
      }
    });
  });
});
onBeforeRouteUpdate((to, from) => {
  console.log('before route update');
  console.log(to.params.path);
  if (to.params.path !== from.params.path) {
    let targetpath = to.params.path;
    if (!to.params.path) {
      targetpath = '/blog/Home.md';
    }
    if (to.params.path === '/') {
      targetpath = '/blog/Home.md';
    }
    if (to.params.path === '/Home.md') {
      targetpath = '/blog/Home.md';
    }
    if (to.params.path === 'Home.md') {
      targetpath = '/blog/Home.md';
    }
    console.log(targetpath);
    console.log('start axios');
    axios.get(`${targetpath}`).then((res) => {
      // console.log(res.status);
      // console.log(res.data);
      try {
        content.value = getHtmlFromMd(res.data);
      } catch (e) {
        console.error(e);
      }
      goAnchor('head');
    }).catch((err) => {
      axios.get('/blog/404.md').then((res2) => {
        try {
          content.value = getHtmlFromMd(res2.data);
        } catch (e) {
          console.log(e);
        }
      });
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "home-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
        }, [
          _createTextVNode("返回"),
          _hoisted_5,
          _createTextVNode("首页")
        ]),
        _hoisted_6,
        _hoisted_7
      ])
    ]),
    (_openBlock(), _createElementBlock("div", {
      innerHTML: content.value,
      key: _ctx.$route.fullPath,
      id: "content"
    }, null, 8, _hoisted_8)),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createTextVNode("  "),
      _hoisted_11,
      _hoisted_12,
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _createElementVNode("span", null, " " + _toDisplayString(timestr.value) + " ", 1)
    ]),
    _hoisted_16
  ]))
}
}

})